<!--TOP-->
@if (anchor === anchorEnum.Top && showAlerts) {
  <div class="snackbar snackbar__{{ severity }} snackbar--{{ anchor }}"
     [ngClass]="{
         'snackbar--full': full,
         'fullMenuClosed': full && menuClosed,
         'menuClosed': menuClosed
     }"
    [@inOutAnimation]="animation"
    [ngStyle]="{top: anchor === anchorEnum.Top ? gap : 0}"
    >
    <div class="content">
      <div class="pre">
        <ng-content select="[pre-top]"></ng-content>
      </div>
      <div class="text">
        <ng-content select="[text-top]"></ng-content>
      </div>
      <div class="post">
        <ng-content select="[post-top]"></ng-content>
      </div>
    </div>
  </div>
}

<!--BOTTOM-->
@if (anchor === anchorEnum.Bottom && showAlerts) {
  <div class="snackbar snackbar__{{ severity }} snackbar--{{ anchor }}"
     [ngClass]="{
         'snackbar--full': full,
         'fullMenuClosed': full && menuClosed,
         'menuClosed': menuClosed
     }"
    [ngStyle]="{bottom: gap}"
    >
    <div class="content">
      <div class="pre">
        <ng-content select="[pre-bottom]"></ng-content>
      </div>
      <div class="text">
        <ng-content select="[text-bottom]"></ng-content>
      </div>
      <div class="post">
        <ng-content select="[post-bottom]"></ng-content>
      </div>
    </div>
  </div>
}
